
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trains/news",
      function () {
        return require("private-next-pages/trains/news.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trains/news"])
      });
    }
  